import { render, staticRenderFns } from "./SelectedColumnsButton.vue?vue&type=template&id=1b30bd8e&"
import script from "./SelectedColumnsButton.vue?vue&type=script&lang=js&"
export * from "./SelectedColumnsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports